import * as React from 'react';

import FileNumbers32 from './FileNumbers32';

export const fileNumbers32 = () => <FileNumbers32 />;

export default {
    title: 'Icon/Content/FileNumbers32',
    component: FileNumbers32,
    parameters: {
        notes: "`import FileNumbers32 from 'box-ui-elements/es/icon/content/FileNumbers32';`",
    },
};
